import React from 'react';
import { Paper, Grid, Typography } from '@material-ui/core';

export default function CacheUpdateInfo({ lastCacheUpdate }) {
  if (!lastCacheUpdate || lastCacheUpdate.id === 0) {
    return null;
  }

  return (
    <Paper style={{ padding: '16px', marginBottom: '24px' }}>
      <Grid container spacing={2}>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="textSecondary">
            Last Updated
          </Typography>
          <Typography variant="body1">
            {new Date(lastCacheUpdate.updated_at).toLocaleString()}
          </Typography>
        </Grid>
        <Grid item xs={12} md={6}>
          <Typography variant="subtitle2" color="textSecondary">
            Duration
          </Typography>
          <Typography variant="body1">
            {lastCacheUpdate.duration_seconds} seconds
          </Typography>
        </Grid>
      </Grid>
    </Paper>
  );
} 